import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css"

function MobileAppDevelopment() {
        useEffect(()=>{
            AOS.init({duration:1000, once:true});
        }, []);

    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Mobile App Development</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2  data-aos="fade-up">Our Mobile App Development Services</h2>
                        <p className="section-description">
                        We design and develop feature-rich mobile applications for iOS and Android that are tailored to your business goals. Our solutions combine innovation, usability, and performance to deliver apps that engage users and drive growth.                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="300">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-user-friends"></i>
                            </div>
                            <h3>Consumer Apps</h3>
                            <p>Create customer-focused mobile experiences with sleek designs, intuitive navigation, and engaging features.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-building"></i>
                            </div>
                            <h3>Enterprise Apps</h3>
                            <p>Build secure, enterprise-grade applications that streamline processes, enhance collaboration, and boost efficiency.
</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-sync"></i>
                            </div>
                            <h3>Cross-Platform Apps</h3>
                            <p>Deliver affordable cross-platform apps that function seamlessly on iOS and Android with a single, optimized codebase.</p>
                        </div>

                        {/* <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-palette"></i>
                            </div>
                            <h3>UI/UX Design</h3>
                            <p>Beautiful, user-friendly interfaces designed to maximize engagement and retention.</p>
                        </div> */}
                    </div>
                </div>
            </section>

            

            {/* App Development Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our App Development Process</h2>
                        <p className="section-description">
                            A proven methodology to deliver high-quality mobile applications
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Requirement Analysis</h3>
                                <p>Assess your goals, target audience, and technical needs to shape a custom app strategy.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200" >
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>UI/UX Design</h3>
                                <p>Design clean, user-friendly interfaces and smooth user experiences aligned with your brand.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200" >
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>App Development</h3>
                                <p>Develop robust mobile applications using the latest frameworks and best practices.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>API Integration</h3>
                                <p>Connect your app with APIs, backend systems, and external services for a seamless experience.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Quality Assurance</h3>
                                <p>Perform extensive testing on multiple devices to guarantee performance, security, and stability.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Deployment & Support</h3>
                                <p>Launch your app on iOS and Android stores, followed by continuous support, updates, and improvements.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technologies We Use Section */}
            <section className="why-choose-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Technologies We Use</h2>
                        <p className="section-description">
                            We leverage cutting-edge tools and frameworks to build powerful mobile applications
                        </p>
                    </div>

                    <div className="features-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-apple"></i>
                            </div>
                            <h3>iOS Development</h3>
                            <p>Swift and Objective-C to deliver optimized iOS applications.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-android"></i>
                            </div>
                            <h3>Android Development</h3>
                            <p>Kotlin and Java for powerful, reliable Android experiences.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-react"></i>
                            </div>
                            <h3>React Native</h3>
                            <p>A single codebase for both iOS and Android with near-native performance.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-google"></i>
                            </div>
                            <h3>Flutter</h3>
                            <p>Google’s toolkit for creating visually appealing, high-performance cross-platform apps.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-database"></i>
                            </div>
                            <h3>Backend Technologies</h3>
                            <p>Node.js, Firebase, AWS, and other platforms for strong infrastructure and seamless integrations.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-lock"></i>
                            </div>
                            <h3>Security Frameworks</h3>
                            <p>Industry-leading encryption, authentication, and data protection standards to safeguard users.</p>
                        </div>
                    </div>
                </div>
            </section>

           

            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Build Your Mobile App?</h2>
                        <p>Let's create an innovative mobile solution that drives engagement and results for your business.</p>
                        <a href="/contact" className="cta-button">Get a Free Consultation</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default MobileAppDevelopment;
